import { createDeformedCube, depthRatio } from "./CubeBase";

// 誤り1: 幅方向の発散遠近（収束不足）
// 上面の後退する辺ペア（文献の辺A・C）を平行以上に開いて描く誤り（80名中43名）。
// 奥の垂直辺（辺E）が外側にずれる誤りもこれに含まれる。
// デッサンを正とすると、奥に行くほど幅が広がる立体になる。
// shearValue: 0=正解(立方体), 0.5=誤り, 0.2=中間
export function createCubeModel1(shearValue, faceColors, errorEdges) {
  shearValue = shearValue !== undefined ? shearValue : 0.5;
  return createDeformedCube((x, y, z) => [
    (y>0 ? x * (1 +0.4* shearValue * depthRatio(z)) : x),
    y,
    z,
  ], faceColors, errorEdges);
}
